@if(eventServices) {
  <div class="card card-flush">
    <div class="card-header mt-5">
      <div class="card-title flex-column">
        <h3 class="fw-bold mb-1">Event Services</h3>
        <div class="fs-6 text-gray-500">Total number of services {{ eventServices.length }}</div>
      </div>
      <div class="card-toolbar my-1">
        <app-button
          [variant]="'primary'"
          [label]="'Add Service'"
          [iconClass]="'fa fa-plus'"
          [size]="'md'"
          class="ms-2"
          (clicked)="openAddEventServiceModal()"
        />
      </div>
    </div>
    <div class="card-body pt-0">
      <div class="table-responsive">
        <table id="kt_profile_overview_table" class="table table-row-bordered table-row-dashed gy-4 align-middle fw-bold">
          <thead class="fs-7 text-gray-500 text-uppercase">
          <tr>
            <th class="min-w-250px">Name</th>
            <th class="min-w-90px">Description</th>
            <th class="min-w-90px">Registrations</th>
            <th class="min-w-50px ">Price</th>
            <th class="min-w-50px ">Total</th>
            <th class="text-end min-w-70px">Actions</th>
          </tr>
          </thead>
          <tbody class="fs-6">
            @for (service of eventServices; track service.event_service_id) {
              <tr class="cursor-pointer" (click)="openViewRegistrationsModal(service)">
                <td>
                  <div class="d-flex align-items-center">
                    <div class="d-flex flex-column justify-content-center">
                      <span class="fs-6 text-gray-800">{{ service.event_service_name }}</span>
                    </div>
                  </div>
                </td>
                <td>{{ service.event_service_description}}</td>
                <td>{{ getTotalRegistrations(service) }} / {{ service.max_num_registrations }}</td>
                <td>{{ service.price || 0 }} {{service.price_currency}}</td>
                <td>{{ (service.price || 0) * getTotalRegistrations(service) }} {{service.price_currency}}</td>
                <td class="text-end" (click)="$event.stopPropagation()">
                  <div class="dropdown">
                    <button
                      class="btn btn-sm btn-icon btn-light btn-active-light-primary"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="fa fa-ellipsis-v"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item" (click)="openViewRegistrationsModal(service)">
                          <i class="far fa-eye me-2"></i>
                          View Registrations
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="openEditEventServiceModal(service)">
                          <i class="far fa-edit me-2"></i>
                          Edit Service
                        </a>
                      </li>
                      <li><hr class="dropdown-divider"></li>
                      <li>
                        <a class="dropdown-item text-danger" (click)="deleteEventService(service)">
                          <i class="far fa-trash-can me-2"></i>
                          Delete Service
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
